document.addEventListener("click", (e) => {
  const parentLink = e.target.closest("details.mega-menu > summary .mega-menu__parent-link");
  if (!parentLink) return;

  // Evita que el click en el link también haga toggle del <details>
  e.stopPropagation();
  // No usamos preventDefault porque queremos navegar
});
